
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../../Components/Dialog.js";
import { singleton, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TextButton } from "../../../Components/Button.js";

export function ArchiveDialog(props) {
    let Title;
    const t = useTranslation()[0];
    return createElement(Dialog, (Title = t("user.archive"), {
        Body: toList(delay(() => {
            let elems, elems_1;
            return !props.IsArchived ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [t("user.archive_receiver_information")], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [t("user.reactivate_receiver_information")], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "archived-dialog-close",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: "enabled",
            Label: props.IsArchived ? t("receivers.archive_dialog.unarchive") : t("receivers.archive_dialog.archive"),
            OnClick: () => {
                props.OnSave();
                props.OnClose();
            },
            TestId: "archived-dialog-save",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

